import { render, staticRenderFns } from "./CopyModal.vue?vue&type=template&id=12df1c30&scoped=true&"
import script from "./CopyModal.vue?vue&type=script&lang=ts&"
export * from "./CopyModal.vue?vue&type=script&lang=ts&"
import style0 from "./CopyModal.vue?vue&type=style&index=0&id=12df1c30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12df1c30",
  null
  
)

export default component.exports